/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Genres_Meta_DescriptionInputs */

const id_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre di egdata.app`)
};

const ms_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre di egdata.app`)
};

const da_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer på egdata.app`)
};

const de_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres auf egdata.app`)
};

const en_us2_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres on egdata.app`)
};

const es_es2_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros en egdata.app`)
};

const es_mx2_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros en egdata.app`)
};

const fil_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Genre sa egdata.app`)
};

const fr_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres sur egdata.app`)
};

const it_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generi su egdata.app`)
};

const hu_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Műfajok az egdata.app-on`)
};

const nl_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres op egdata.app`)
};

const no_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjangre på egdata.app`)
};

const pl_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatunki na egdata.app`)
};

const pt_br2_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gêneros em egdata.app`)
};

const pt_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros no egdata.app`)
};

const ro_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genuri pe egdata.app`)
};

const fi_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lajityypit egdata.appissa`)
};

const sv_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer på egdata.app`)
};

const vi_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thể loại trên egdata.app`)
};

const tr_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app'teki türler`)
};

const cs_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žánry na egdata.app`)
};

const bg_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанрове на egdata.app`)
};

const ru_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанры на egdata.app`)
};

const uk_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанри на egdata.app`)
};

const ar_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأنواع على egdata.app`)
};

const hi_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app पर शैलियाँ`)
};

const th_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แนวเกมบน egdata.app`)
};

const ja_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app のジャンル`)
};

const zh_cn2_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app上的游戏类型`)
};

const zh_hant1_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app上的遊戲類型`)
};

const ko_genres_meta_description = /** @type {(inputs: Genres_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app의 장르`)
};

/**
* | output |
* | --- |
* | "Genres on egdata.app" |
*
* @param {Genres_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const genres_meta_description = /** @type {((inputs?: Genres_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Genres_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_genres_meta_description(inputs)
	if (locale === "ms") return ms_genres_meta_description(inputs)
	if (locale === "da") return da_genres_meta_description(inputs)
	if (locale === "de") return de_genres_meta_description(inputs)
	if (locale === "en-US") return en_us2_genres_meta_description(inputs)
	if (locale === "es-ES") return es_es2_genres_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_genres_meta_description(inputs)
	if (locale === "fil") return fil_genres_meta_description(inputs)
	if (locale === "fr") return fr_genres_meta_description(inputs)
	if (locale === "it") return it_genres_meta_description(inputs)
	if (locale === "hu") return hu_genres_meta_description(inputs)
	if (locale === "nl") return nl_genres_meta_description(inputs)
	if (locale === "no") return no_genres_meta_description(inputs)
	if (locale === "pl") return pl_genres_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_genres_meta_description(inputs)
	if (locale === "pt") return pt_genres_meta_description(inputs)
	if (locale === "ro") return ro_genres_meta_description(inputs)
	if (locale === "fi") return fi_genres_meta_description(inputs)
	if (locale === "sv") return sv_genres_meta_description(inputs)
	if (locale === "vi") return vi_genres_meta_description(inputs)
	if (locale === "tr") return tr_genres_meta_description(inputs)
	if (locale === "cs") return cs_genres_meta_description(inputs)
	if (locale === "bg") return bg_genres_meta_description(inputs)
	if (locale === "ru") return ru_genres_meta_description(inputs)
	if (locale === "uk") return uk_genres_meta_description(inputs)
	if (locale === "ar") return ar_genres_meta_description(inputs)
	if (locale === "hi") return hi_genres_meta_description(inputs)
	if (locale === "th") return th_genres_meta_description(inputs)
	if (locale === "ja") return ja_genres_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_genres_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_genres_meta_description(inputs)
	return ko_genres_meta_description(inputs)
});
export { genres_meta_description as "genres.meta.description" }